import React from 'react'
import { pinguinoAzulRegistro } from '../../../../assets/ImgLinks'

const HeaderRegistro = () => {
  return (
    <div className='p-3'>
      <div className='d-flex align-items-center justify-content-center'>
        <img style={{width:'20vw'}} className='rounded' src={pinguinoAzulRegistro} alt="pinguinoAzulRegistro" />
        <h3 style={{color:'#3ABDBC'}} className='fs-1 ms-3'>REGISTRO</h3>
      </div>
      <h3 style={{color:'#915DCF'}} className='mt-3 fs-4 text-center'>Completa la Información Requerida</h3>
    </div>
  )
}

export default HeaderRegistro